
import Draw from 'ol/interaction/Draw';
import EventType from 'ol/events/EventType';

class DrawMeasure extends Draw {

    constructor(options) {
        super(options);
        this.onPointerMove = options.onPointerMove;
    }

    handleEvent(mapBrowserEvent) {
        if (mapBrowserEvent.type == EventType.KEYDOWN) {
            this.processKeyDown(mapBrowserEvent.originalEvent);
        }
        return super.handleEvent(mapBrowserEvent);
    }

    handlePointerMove_(event) {
        let result = super.handlePointerMove_(event);
        if (this.onPointerMove) {
            this.onPointerMove(event);
        }
        return result;
    }

    processKeyDown(keyEvent) {
        switch (keyEvent.keyCode) {
            case 27:
                this.abortDrawing();
                break;
            case 46:
                this.removeLastPoint();
                break;
            default:
                // nop;
        }
    }
}

export default DrawMeasure;
